import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { SingleOrderResponseV2 } from "./interfacesV2";

const useOrderQuery = ({
  id,
  refetchInterval,retry
}: {
  refetchInterval?: number;
  id?: string;
  retry?: number;
}) => {
  const { t } = useTranslation();
  const branch = useBranchId();
  const enabled = Boolean(parseInt(id) && branch);
  const queryKey = ["v2", "order", id, branch];
  const query = useQuery<SingleOrderResponseV2>({
    refetchInterval: enabled ? refetchInterval : false,
    queryKey: queryKey,
    retry: retry ?? undefined,
    queryFn: async () => {
      if (enabled) {
        return get2(
          `/internal/secure/pos/v2/orders/single/${branch}/${id}?hasOffset=0`
        );
      }
      return null;
    },
    enabled,
  });

  useEffect(() => {
    if (query.isError && id) {
      const error = query.error as any;
      const status = error?.response?.status as any;
      toast.error(t(`errors.${status}`));
    }
  }, [query.isError, id]);

  return query;
};

export default useOrderQuery;
